export { default } from './promotion-modal';
